import {
  FREQUENCY_VALUES,
  type FrequencyKey,
} from "@/lib/tool-kit/finance/currency";
import {
  CONTINUOUS,
  effectiveAnnualRate,
  nominalFromEffective,
} from "@/lib/tool-kit/finance/tvm";

export type CompoundingKey = FrequencyKey | "continuous";

/** Every compounding frequency the converter lists, longest period first. */
export const RATE_FREQUENCIES: readonly CompoundingKey[] = [
  "annually",
  "semiannually",
  "quarterly",
  "bimonthly",
  "monthly",
  "semimonthly",
  "biweekly",
  "weekly",
  "daily",
  "continuous",
];

export function perYearFor(key: CompoundingKey): number {
  return key === "continuous" ? CONTINUOUS : FREQUENCY_VALUES[key];
}

export interface RateRow {
  key: CompoundingKey;
  perYear: number;
  /** The converted rate as a decimal. */
  rate: number;
}

/** The effective annual rate of one nominal rate at every compounding frequency. */
export function apyTable(apr: number): RateRow[] {
  return RATE_FREQUENCIES.map((key) => ({
    key,
    perYear: perYearFor(key),
    rate: effectiveAnnualRate(apr, perYearFor(key)),
  }));
}

/** The nominal rate that produces one effective rate at every compounding frequency. */
export function aprTable(apy: number): RateRow[] {
  return RATE_FREQUENCIES.map((key) => ({
    key,
    perYear: perYearFor(key),
    rate: nominalFromEffective(apy, perYearFor(key)),
  }));
}
